module.exports = __webpack_public_path__ + "img/機能01_オンライン試験勉強.3d3a5d60.png";